module.exports = __webpack_public_path__ + "img/list-light-01.8d7faedf.png";